import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect } from 'react';
import { fetchTjenesteTekster, selectFeedbackResources } from '@helsenorge/framework-utils/cms-tjeneste-tekster';
import { getPath } from '@helsenorge/framework-utils/hn-page';
import { selectCurrentLanguage } from '@helsenorge/framework-utils/language';
import FeedbackForm from '..';
import { useAppDispatch, useAppSelector } from '../../store/hooks';
const FeedbackContainer = ({ url, pageTitle, tjenesteNavn = getPath() }) => {
    const dispatch = useAppDispatch();
    const feedbackResources = useAppSelector(state => selectFeedbackResources(state, tjenesteNavn));
    const language = useAppSelector(state => selectCurrentLanguage(state.language));
    useEffect(() => {
        dispatch(fetchTjenesteTekster({ name: tjenesteNavn, language }));
    }, [tjenesteNavn, language]);
    if (!feedbackResources) {
        return null;
    }
    return _jsx(FeedbackForm, { url: url, pageTitle: pageTitle, resources: feedbackResources });
};
export default FeedbackContainer;
